module.exports = __webpack_public_path__ + "img/benefit_day-of-golf.dd1073da.jpg";